export interface IUpdateUnosDataItemRequest {
    id: number,
    dataYear: number,
    deceasedDonorCount: number,
    livingDonorCount: number,
    unosNddCount: number,
    unosKpdCount: number,
    waitListCount: number
}